export const configIcon = subicon => ['configure', {name: subicon, color: 'grey'}]
